import {ChangeDetectionStrategy, Component, HostBinding, inject} from '@angular/core';
import {AppLocale, DEFAULT_LOCALE, LocaleSwitcherBase} from 'compob2b-libs';
import {LocaleService} from './locale.service';

@Component({
  selector: 'app-locale-switcher',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <select class="locale-switcher"
            (change)="onSelect($event)"
            aria-label="Language">
      @for (l of locales; track l) {
        <option [value]="l" [selected]="l === active">{{ l.toUpperCase() }}</option>
      }
    </select>
  `,
  styles: [`
    :host { display: inline-flex; }
    :host(.hidden) { display: none; }
    .locale-switcher {
      background: transparent;
      border: 0;
      color: inherit;
      font: inherit;
      font-size: 0.85rem;
      font-weight: 500;
      line-height: 1;
      cursor: pointer;
      padding: 0.15rem 0.25rem;
      border-radius: 4px;
    }
    .locale-switcher:hover { opacity: 0.8; }
    .locale-switcher:focus-visible { outline: none; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.15); }
    /* Пункты раскрытого списка рисуются в нативном меню ОС — задаём читаемый цвет. */
    .locale-switcher option { color: #1f2937; font-weight: 500; }
  `],
})
export class LocaleSwitcherComponent extends LocaleSwitcherBase<AppLocale> {
  active: AppLocale = DEFAULT_LOCALE;
  protected readonly service = inject(LocaleService);

  /** Языки текущей витрины — дропдаун строится по ним (вне витрины — все supported). */
  readonly locales = this.service.availableLocales;

  /** Скрываем переключатель, если выключен aiTranslation или доступен лишь один язык. */
  @HostBinding('class.hidden') get hidden(): boolean {
    return !this.environment.aiTranslation || this.locales.length <= 1;
  }

  onSelect(event: Event) {
    this.select((event.target as HTMLSelectElement).value as AppLocale);
  }
}
